export default __webpack_public_path__ + "static/media/to-pay.121e39a1.svg";